namespace Nobox {
    export interface ChatroomagentsListRequest extends Serenity.ListRequest {
        Menu?: string;
        IdContact?: number;
    }
}
